export default [
  {
    path: 'live-list',
    name: 'LiveList',
    meta: {
      isDynamic: true,
      id: '直播间管理',
      inTab: true
    },
    component: () => import('@/views/Live/LiveList/LiveList.vue')
  },
  {
    path: 'save-live',
    name: 'SaveLive',
    meta: {
      id: '新增直播'
    },
    component: () => import('@/views/Live/SaveLive/SaveLive.vue')
  },
  {
    path: 'live-subscribe-list',
    name: 'LiveSubscribeList',
    meta: {
      id: '直播预约记录'
    },
    component: () => import('@/views/Live/LiveSubscribeList/LiveSubscribeList.vue')
  }
];
